<template>
  <el-container class="main">
    <el-header class="header" id="print-header">
      <div class="left">
        <img src="@/assets/logo.png" alt="">
        <span class="title">{{ systemTitle || '智慧应用管理平台' }}</span>
      </div>
      <div class="header-right">
        <span>欢迎，</span>
        <i class="user-icon el-icon-user-solid"></i>
        <el-dropdown trigger="click" class="info">
          <span class="el-dropdown-link">
            {{ user.loginId }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="editPassword">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container class="main-content">
      <el-aside id="print-aside">
        <side-bar></side-bar>
      </el-aside>
      <el-main id="print-content">
        <keep-alive :include="keepAlive">
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>

    <!-- 独立密码弹窗组件 -->
    <ModifyPassword :visible.sync="pwdDialogVisible" :user-id="user.userId" />
  </el-container>
</template>

<script>
import SideBar from './SideBar'
import ModifyPassword from '@/components/ModifyPassword.vue'

export default {
  name: 'Index',
  components: {
    SideBar,
    ModifyPassword
  },
  data() {
    return {
      loggingOut: false,
      pwdDialogVisible: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    systemTitle() {
      return this.$store.state.systemTitle
    },
    keepAlive() {
      return this.$store.state.keepAlive
    }
  },
  methods: {
    async exit() {
      if (this.loggingOut) return
      this.loggingOut = true
      try {
        await this.$store.dispatch('logout')
      } catch (error) {
        // 请求拦截器已展示错误，保留当前页面以便重试注销。
      } finally {
        this.loggingOut = false
      }
    },
    editPassword() {
      this.pwdDialogVisible = true
    }
  }
}
</script>

<style>
@media print {
  /* 重置所有margin，去掉浏览器默认边距 */
  @page {
    margin: 0;
    size: A4;
  }

  body {
    margin: 0;
    print-color-adjust: exact;
    /* 保留背景色 */
    -webkit-print-color-adjust: exact;
  }

  /* 打印容器自动适配A4 */
  #print-content {
    width: 210mm !important;
    margin: 0 auto !important;
    overflow: visible !important;
  }

  .shoufa-form {
    width: 600px !important;
  }

  /* 隐藏不需要打印的按钮、侧边栏 */
  .no-print {
    display: none !important;
  }

  #print-aside {
    display: none !important;
  }

  #print-header {
    display: none !important;
  }
}
</style>
<style scoped lang='scss'>
.main {
  height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
      width: 50px;
      border-radius: 10px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .info {
      color: #ffffff;
      cursor: pointer;
    }

    .user-icon {
      margin-right: 5px;
    }
  }
}

.el-header {
  // background-color: #207cdc;
  // background-image: linear-gradient(to right, #0e1631, #12245b);
  background: linear-gradient(270deg, #06CED4 0%, #0E6AD7 100%);
  color: #fff;
  display: flex;
  align-items: center;
  height: 60px !important;

  .title {
    font-size: 20px;
  }
}

.main-content {
  height: 0;
  background-color: #E8EAF6;
}

.el-aside {
  width: 200px !important;
  background-color: #282F4A;
  overflow-x: hidden;
  animation: right .5s;

  &::-webkit-scrollbar {
    width: 0;
  }
}

@keyframes right {
  0% {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.el-main {
  background-color: #E8EAF6;
  position: relative;
  animation: left .5s;
}

@keyframes left {
  0% {
    transform: translate3d(100px, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
</style>
